import fecha from 'fecha';

const defaultConfig = {};
const defaultI18n = 'RU';
const availableMonths = {
  EN: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November',
    'December'],
  RU: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь',
    'Декабрь']
};

const availableShortDays = {
  EN: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  RU: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс']
};

const presetRangeLabel = {
  EN: {
    today: 'Today',
    thisMonth: 'This Month',
    lastMonth: 'Last Month',
    lastSevenDays: 'Last 7 Days',
    lastThirtyDays: 'Last 30 Days'
  },
  RU: {
    today: 'Сегодня',
    thisMonth: 'Текущий месяц',
    lastMonth: 'Предыдущий месяц',
    lastSevenDays: 'Последние 7 дней',
    lastThirtyDays: 'Последние 30 дней'
  }
};

const defaultCaptions = {
  'title': 'Choose Dates',
  'ok_button': 'Apply'
};

const defaultStyle = {
  daysWeeks: 'calendar_weeks',
  days: 'calendar_days',
  daysSelected: {
    start: 'calendar_days_selected start',
    end: 'calendar_days_selected end',
    both: 'calendar_days_selected start end'
  },
  daysSelectedEnd: 'calendar_days_selected end',
  daysInRange: 'calendar_days_in-range',
  daysAvailable: 'calendar_days_available',
  firstDate: 'calendar_month_left',
  secondDate: 'calendar_month_right',
  presetRanges: 'calendar_preset-ranges',
  dateDisabled: 'calendar_days--disabled'
};

const defaultPresets = function (i18n = defaultI18n) {
  return {
    today: function () {
      const n = new Date();
      const startToday = new Date(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0);
      const endToday = new Date(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0);
      return {
        label: presetRangeLabel[i18n].today,
        active: false,
        dateRange: {
          start: startToday,
          end: endToday
        }
      };
    },
    thisMonth: function () {
      const n = new Date();
      const startMonth = new Date(n.getFullYear(), n.getMonth(), 1);
      const endMonth = new Date(n.getFullYear(), n.getMonth() + 1, 0);
      
      return {
        label: presetRangeLabel[i18n].thisMonth,
        active: false,
        dateRange: {
          start: startMonth,
          end: endMonth
        }
      };
    },
    lastMonth: function () {
      const n = new Date();
      const startMonth = new Date(n.getFullYear(), n.getMonth() - 1, 1);
      const endMonth = new Date(n.getFullYear(), n.getMonth(), 0);
      return {
        label: presetRangeLabel[i18n].lastMonth,
        active: false,
        dateRange: {
          start: startMonth,
          end: endMonth
        }
      };
    },
    /*last7days: function () {
      const n = new Date();
      const start = new Date(n.getFullYear(), n.getMonth(), n.getDate() - 5);
      const end = new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1);
      return {
        label: presetRangeLabel[i18n].lastSevenDays,
        active: false,
        dateRange: {
          start: start,
          end: end
        }
      };
    },
    last30days: function () {
      const n = new Date();
      const start = new Date(n.getFullYear(), n.getMonth(), n.getDate() - 29);
      const end = new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1);
      return {
        label: presetRangeLabel[i18n].lastThirtyDays,
        active: false,
        dateRange: {
          start: start,
          end: end
        }
      };
    }*/
  };
};

export default {
  //name: 'vue-rangedate-picker',
  props: {
    value: {
      type: Object,
      default: () => null
    },
    configs: {
      type: Object,
      default: () => defaultConfig
    },
    i18n: {
      type: String,
      default: defaultI18n
    },
    months: {
      type: Array,
      default: () => null
    },
    shortDays: {
      type: Array,
      default: () => null
    },
    // options for captions are: title, ok_button
    captions: {
      type: Object,
      default: () => defaultCaptions
    },
    format: {
      type: String,
      default: 'DD MMM YYYY'
    },
    styles: {
      type: Object,
      default: () => {}
    },
    startActiveMonth: {
      type: Number,
      default: new Date().getMonth()
    },
    startActiveYear: {
      type: Number,
      default: new Date().getFullYear()
    },
    presetRanges: {
      type: Object,
      default: () => null
    },
    compact: {
      type: String,
      default: 'false'
    },
    righttoleft: {
      type: String,
      default: 'false'
    }
  },
  data () {
    return {
      dateRange: {},
      numOfDays: 7,
      isFirstChoice: true,
      isOpen: false,
      presetActive: '',
      showMonth: false,
      activeMonthStart: this.startActiveMonth,
      activeYearStart: this.startActiveYear,
      activeYearEnd: this.startActiveYear,
      availableDate: '',
      availableRow: '',
      availableItem: '',
    };
  },
  created () {
    if (this.value) {
      this.dateRange = Object.assign({}, this.dateRange, {
        start: new Date(this.value.from + ':00:00:00'),
        end: new Date((this.value.to || this.value.from) + ':00:00:00'),
      });
    }
    if (this.activeMonthStart === 11) this.activeYearEnd = this.activeYearStart + 1;
  },
  watch: {
    startNextActiveMonth: function (value) {
      if (value === 0) this.activeYearEnd = this.activeYearStart + 1;
    }
  },
  computed: {
    monthsLocale: function () {
      return this.months || availableMonths[this.i18n];
    },
    shortDaysLocale: function () {
      return this.shortDays || availableShortDays[this.i18n];
    },
    s: function () {
      return Object.assign({}, defaultStyle, this.style);
    },
    startMonthDay: function () {
      return new Date(this.activeYearStart, this.activeMonthStart, 0).getDay();
    },
    startNextMonthDay: function () {
      return new Date(this.activeYearEnd, this.startNextActiveMonth, 0).getDay();
    },
    endMonthDate: function () {
      return new Date(this.activeYearEnd, this.startNextActiveMonth, 0).getDate();
    },
    endNextMonthDate: function () {
      return new Date(this.activeYearEnd, this.activeMonthStart + 2, 0).getDate();
    },
    startNextActiveMonth: function () {
      return this.activeMonthStart >= 11 ? 0 : this.activeMonthStart + 1;
    },
    finalPresetRanges: function () {
      const presets = this.presetRanges || defaultPresets(this.i18n);
      let tmp = {};
      
      for (let i in presets) {
        const item = presets[i];
        let plainItem = item;
        if (typeof item === 'function') {
          plainItem = item();
        }
        tmp[i] = plainItem;
      }
      return tmp;
    },
    isCompact: function () {
      return this.compact === 'true';
    },
    isRighttoLeft: function () {
      return this.righttoleft === 'true';
    },
    isAvailable (row, item) {
      return this.isDateInRange(row, item, 'first', this.startMonthDay, this.endMonthDate);
    }
  },
  methods: {
    toggleCalendar: function () {
      if (this.isCompact) {
        this.showMonth = !this.showMonth;
        return;
      }
      this.isOpen = !this.isOpen;
      this.showMonth = !this.showMonth;
      return;
    },
    getDateString: function (date, format = this.format) {
      if (!date) {
        return null;
      }
      const dateparse = new Date(Date.parse(date));
      return fecha.format(new Date(dateparse.getFullYear(), dateparse.getMonth(), dateparse.getDate() - 1), format);
    },
    getDayIndexInMonth: function (r, i, startMonthDay) {
      const date = (this.numOfDays * (r - 1)) + i;
      return date - startMonthDay;
    },
    getDayCell (r, i, startMonthDay, endMonthDate) {
      const result = this.getDayIndexInMonth(r, i, startMonthDay);
      // bound by > 0 and < last day of month
      return result > 0 && result <= endMonthDate ? result : '&nbsp;';
    },
    getNewDateRange (result, activeMonth, activeYear) {
      const newData = {};
      let key = 'start';
      if (!this.isFirstChoice) {
        key = 'end';
      } else {
        newData['end'] = null;
      }
      const resultDate = new Date(activeYear, activeMonth, result);
      if (!this.isFirstChoice && resultDate < this.dateRange.start) {
        this.isFirstChoice = false;
        return {start: resultDate};
      }

      // toggle first choice
      this.isFirstChoice = !this.isFirstChoice;
      newData[key] = resultDate;
      return newData;
    },
    setAvailableDate (r, i, key) {
      let result = '';
      
      if (key === 'first') {
        result = this.getDayIndexInMonth(r, i, this.startMonthDay);
        this.availableDate = new Date(this.activeYearStart, this.activeMonthStart, result);  
      } else {
        result = this.getDayIndexInMonth(r, i, this.startNextMonthDay);
        this.availableDate = new Date(this.activeYearEnd, this.startNextActiveMonth, result);
      }
    },
    selectFirstItem (r, i) {
      const result = this.getDayIndexInMonth(r, i, this.startMonthDay);
      this.dateRange = Object.assign({}, this.dateRange, this.getNewDateRange(result, this.activeMonthStart,
        this.activeYearStart));

      if (this.dateRange.end) {
        this.$emit('selected', this.dateRange);
      } else {
        this.presetActive = '';
      }
    },
    selectSecondItem (r, i) {
      const result = this.getDayIndexInMonth(r, i, this.startNextMonthDay);
      this.dateRange = Object.assign({}, this.dateRange, this.getNewDateRange(result, this.startNextActiveMonth,
        this.activeYearEnd));

      if (this.dateRange.end) {
        this.$emit('selected', this.dateRange);
      } else {
        this.presetActive = '';
      }
    },
    getDateSelectedClass (r, i, key, startMonthDay, endMonthDate) {
      const result = this.getDayIndexInMonth(r, i, startMonthDay);
      if (result < 1 || result > endMonthDate) return false;

      let currDate = null;
      if (key === 'first') {
        currDate = new Date(this.activeYearStart, this.activeMonthStart, result);
      } else {
        currDate = new Date(this.activeYearEnd, this.startNextActiveMonth, result);
      }
      
      let selected = {
        start: false,
        end: false
      };
      
      if (this.dateRange.start && this.dateRange.start.getTime() === currDate.getTime()) {
        selected.start = true;
      }
      
      if (this.dateRange.end && this.dateRange.end.getTime() === currDate.getTime()) {
        selected.end = true;
      }
      
      if (selected.start && selected.end) {
        return this.s.daysSelected.both;
      } else if (selected.start) {
        return this.s.daysSelected.start;
      }  else if (selected.end) {
        return this.s.daysSelected.end;
      } else {
        return '';
      }
    },
    isDateInRange (r, i, key, startMonthDay, endMonthDate) {
      const result = this.getDayIndexInMonth(r, i, startMonthDay);
      if (result < 1 || result > endMonthDate) return false;

      let currDate = null;
      if (key === 'first') {
        currDate = new Date(this.activeYearStart, this.activeMonthStart, result);
      } else {
        currDate = new Date(this.activeYearEnd, this.startNextActiveMonth, result);
      }
      
      return (this.dateRange.start && this.dateRange.start.getTime() < currDate.getTime()) &&
        (this.dateRange.end && this.dateRange.end.getTime() > currDate.getTime());
    },
    isDateAvailable (r, i, key, startMonthDay, endMonthDate) {
      const result = this.getDayIndexInMonth(r, i, startMonthDay);
      if (result < 1 || result > endMonthDate || !this.dateRange.start || this.dateRange.end || !this.availableDate) return false;

      let currDate = null;
      if (key === 'first') {
        currDate = new Date(this.activeYearStart, this.activeMonthStart, result);
      } else {
        currDate = new Date(this.activeYearEnd, this.startNextActiveMonth, result);
      }
      
      return (this.dateRange.start.getTime() <= currDate.getTime()) &&
        (this.availableDate.getTime() >= currDate.getTime());
    },
    isDateDisabled (r, i, startMonthDay, endMonthDate) {
      const result = this.getDayIndexInMonth(r, i, startMonthDay);
      // bound by > 0 and < last day of month
      return !(result > 0 && result <= endMonthDate);
    },
    goPrevMonth () {
      const prevMonth = new Date(this.activeYearStart, this.activeMonthStart, 0);
      this.activeMonthStart = prevMonth.getMonth();
      this.activeYearStart = prevMonth.getFullYear();
      this.activeYearEnd = prevMonth.getFullYear();
    },
    goNextMonth () {
      const nextMonth = new Date(this.activeYearEnd, this.startNextActiveMonth, 1);
      this.activeMonthStart = nextMonth.getMonth();
      this.activeYearStart = nextMonth.getFullYear();
      this.activeYearEnd = nextMonth.getFullYear();
    },
    updatePreset (item) {
      if (this.presetActive === item.label) {
        return;
      }
      this.presetActive = item.label;
      this.dateRange = item.dateRange;
      // update start active month
      this.activeMonthStart = this.dateRange.start.getMonth();
      this.activeYearStart = this.dateRange.start.getFullYear();
      this.activeYearEnd = this.dateRange.end.getFullYear();
      if (this.activeMonthStart === 11) this.activeYearEnd = this.activeYearStart + 1;

      this.$emit('selected', this.dateRange);
    },
    reset () {
      this.presetActive = '';
      this.dateRange = Object.assign({}, this.dateRange, {
        start: null,
        end: null
      });
      this.$emit('selected', this.dateRange);
    },
    setDateValue: function () {
      this.$emit('selected', this.dateRange);
      if (!this.isCompact) {
        this.toggleCalendar();
      }
    }
  }
};


// WEBPACK FOOTER //
// ./resources/assets/js/components/RangedatePicker/helpers.js